import { isCollaborator, isExecutive, isOrganizationAdmin, isReportingManager, isTeamManager } from "@packages/core/session/roles.ts";
import type { Session } from "@packages/core/session/session.ts";

export function getRoleEventProperties(session: Session) {
    return {
        "Is Reporting Manager": isReportingManager(session),
        "Is Team Manager": isTeamManager(session),
        "Is Admin": isOrganizationAdmin(session),
        "Is Executive": isExecutive(session),
        "Executive Assignations": session.executiveAssignations,
        "Is Collaborator": isCollaborator(session),
        "Collaborator Assignations": session.collaboratorAssignations
    };
}
